/* eslint-disable no-use-before-define */
/* eslint-disable consistent-return */
const onDOMContentLoaded = () =>
  new Promise((resolve, reject) => {
    if (document.readyState === 'interactive') return resolve();

    const removeListeners = () => {
      window.removeEventListener('error', err);
      window.removeEventListener('DOMContentLoaded', ready);
    };

    const err = (e) => {
      removeListeners();
      return reject(e);
    };

    const ready = (e) => {
      removeListeners();
      return resolve(e);
    };

    window.addEventListener('error', err);
    window.addEventListener('DOMContentLoaded', ready);
  });

export default onDOMContentLoaded;
